// src/components/HomeHero.jsx
import { Container, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import heroBg from '../assets/hero.png'; // ← replace with your actual image path

const HomeHero = () => {
  return (
    <div
      style={{
        position: 'relative',
        backgroundImage: `url(${heroBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100%',
      }}
    >
      {/* Dark overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
        }}
      />

      {/* Content */}
      <Container
        className="h-100 d-flex flex-column justify-content-center align-items-center text-center text-white"
        style={{ position: 'relative', zIndex: 1 }}
      >
        <h1 className="display-4">
          Estamos aqui para te entregar<br/>o seu melhor visual
        </h1>
        <Button
          href="https://wa.me/555384339680"
          target="_blank"
          className="mt-4 text-dark text-uppercase px-4 py-2"
          style={{ backgroundColor: '#b68e5d', border: 'none' }}
        >
          Agendar
        </Button>
      </Container>
    </div>
  );
};

export default HomeHero;
